import { __decorate, __metadata } from "tslib";
import { Guid } from 'guid-typescript';
import { Type } from 'class-transformer';
import { format } from 'date-fns';
import EngagementStage from './engagementStage';
let EngagementModel = /** @class */ (() => {
    var _a;
    class EngagementModel {
        constructor() {
            this.id = Guid.create();
            this.name = '';
            this.type = '';
            this.doneHours = 0;
            this.totalHours = 0;
            this.currentStageName = '';
            this.projectType = { value: '', id: null };
            this.prospectName = '';
            this.createdOnAsString = '';
            this.createdOnAsInputString = '';
            this.stages = [];
        }
    }
    __decorate([
        Type(() => Date),
        __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
    ], EngagementModel.prototype, "createdOn", void 0);
    __decorate([
        Type(() => EngagementStage),
        __metadata("design:type", Array)
    ], EngagementModel.prototype, "stages", void 0);
    return EngagementModel;
})();
export { EngagementModel };
export class Engagement extends EngagementModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
    get stageCount() {
        return this.stages.length;
    }
    get activityRatio() {
        return (this.completedActivitiesCount.toString() +
            '/' +
            this.totalActivitiesCount.toString());
    }
    get effortRatio() {
        return this.doneHours.toString() + '/' + this.totalHours.toString();
    }
    get elapsedDays() {
        const diffInMs = Math.abs(new Date().getTime() - this.createdOn.getTime());
        return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    }
    get shortDate() {
        return format(this.createdOn, 'd MMM yyyy');
    }
    get totalActivitiesCount() {
        var c = 0;
        this.stages.forEach(function (value) {
            c += value.activities.length;
        });
        return c;
    }
    get completedActivitiesCount() {
        var c = 0;
        this.stages.forEach(function (value) {
            if (value.activities.length > 0) {
                c += value.activities.filter(x => x.isDone === true).length;
            }
        });
        return c;
    }
}
